import { render } from "./SuEdit.vue?vue&type=template&id=22ea2aa6"
import script from "./SuEdit.vue?vue&type=script&lang=js"
export * from "./SuEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__